<template>
  <div class="app-install-popup">
    <header class="header-main">
      <div class="header-main-box">
        <h1 class="new-logo">
          <svg width="90" height="20" viewBox="0 0 90 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_389_4588)">
              <path d="M46.279 3.59729C46.279 7.08568 47.1729 10.3646 48.7448 13.2199C49.0222 9.69961 50.165 6.42185 51.9586 3.59729H57.8503C54.9815 7.5661 53.2211 12.3881 53.0231 17.6077H45.8037C42.8625 13.6862 41.082 8.84644 40.9694 3.59729H46.279Z" fill="white"/>
              <path d="M63.862 3.59729C63.862 7.08568 64.7559 10.3646 66.3278 13.2199C66.6052 9.69961 67.748 6.42185 69.5416 3.59729H75.4333C72.5645 7.5661 70.8041 12.3881 70.6061 17.6077H63.3867C60.4455 13.6862 58.665 8.84644 58.5524 3.59729H63.862Z" fill="white"/>
              <path d="M19.4167 17.6076C19.0919 12.73 20.403 7.76368 23.3489 3.59726H17.4868C16.1117 6.02304 15.3696 8.71033 15.2629 11.4177C14.0869 8.34114 13.7562 5.01604 14.2683 1.79863H9.54185C7.753 4.74388 6.85323 8.07608 6.84138 11.4106C5.56701 7.73528 5.2991 3.78895 6.03764 0H0.28461C-0.698134 6.53423 0.864299 13.3761 4.96954 18.9329H10.7712C10.2413 16.3225 10.2721 13.6199 10.8625 11.0201C11.3366 13.3335 12.253 15.5735 13.6103 17.6076H19.4167Z" fill="white"/>
              <path d="M34.7438 3.59725C34.6774 3.95342 34.617 4.3096 34.5613 4.66696C33.3011 3.65878 31.7209 3.08606 30.0032 3.08606C25.8292 3.08606 22.5348 6.41944 22.5348 10.6024C22.5348 14.7854 25.8292 18.1188 30.0032 18.1188C31.7209 18.1188 33.3011 17.5461 34.5613 16.5379C34.617 16.8953 34.6774 17.2514 34.7438 17.6076H39.4904C38.6333 12.9797 38.6333 8.22517 39.4904 3.59725H34.7438ZM30.6884 13.7074C28.8201 13.7074 27.5303 12.317 27.5303 10.6024C27.5303 8.88782 28.8201 7.49743 30.6884 7.49743C32.5567 7.49743 33.8464 8.88782 33.8464 10.6024C33.8464 12.317 32.5567 13.7074 30.6884 13.7074Z" fill="white"/>
              <path d="M82.3713 3.08606C77.3556 3.08606 74.4465 6.69515 74.4465 10.5326C74.4465 14.6908 77.5299 18.1188 82.9415 18.1188C85.2686 18.1188 87.6146 17.4656 89.0893 16.7438V12.62C87.6004 13.401 85.5638 14.0956 83.6078 14.0956C81.2795 14.0956 79.8131 13.1477 79.3946 11.742H89.9606C90.3957 6.59338 87.2767 3.08606 82.3725 3.08606H82.3713ZM79.378 8.9813C79.8107 7.54713 81.0057 6.83951 82.3796 6.83951C83.7536 6.83951 84.888 7.58618 85.3255 8.9813H79.378Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_389_4588">
                <rect width="90" height="18.9329" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <span class="a11y-hidden">웨이브</span>
        </h1>
      </div>
    </header>
    <div class="app-install-contents">
      <h2>
        <span><i>JUST DIVE!</i></span>
        <span>Wavve</span>
      </h2>
      <p>
        <span>더블 광고형 스탠다드 이용권 출시!</span>
        <span>월 7,000원에 웨이브와 티빙을 동시에 즐기세요.</span>
        <span class="identity-verification">(PC, 모바일 웹에서만 구매 가능합니다.)</span>
      </p>
      <div class="app-install-download">
        <h3>지금 다운로드 받으세요!</h3>
        <div class="app-download-list">
          <ul>
            <li>
              <a href="https://apps.apple.com/kr/app/wavve-%EC%9B%A8%EC%9D%B4%EB%B8%8C/id987782077">
                <img src="./assets/images/icon-app-store.png" alt="App store 로고">
                <span>App Store</span>
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=kr.co.captv.pooqV2&hl=ko">
                <img src="./assets/images/icon-google-play.png" alt="Google Play 로고">
                <span>Google Play</span>
              </a>
            </li>
            <li>
              <a href="https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000741215">
                <img src="./assets/images/icon-one-store.png" alt="ONE Store 로고">
                <span>ONE Store</span>
              </a>
            </li>
          </ul>
        </div>
        <a href="#" @click.prevent="goMobileWeb" class="link-mobile-web">모바일 웹으로 볼게요</a>
      </div>
    </div>
  </div>
</template>
<script>
import {
  comparePath, DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS,
  getDeviceType,
  getLinkList, openAndroidDeepLink,
  openIosDeepLink,
  stringifyUrl
} from "@/util/common.util";
import { parseUrl } from 'query-string'
import _ from 'lodash'
import deeplink from '@/assets/deeplink.csv'
const makeEmptyObject = keyList => {
  return keyList.reduce((acc, key) => {
    acc[key] = ''
    return acc
  }, {})
}
const removeExceptionalParam = obj => {
  const exceptionalKeyList = ['uitype']
  Object.keys(obj).forEach(key=>{
    if(exceptionalKeyList.indexOf(key) > -1)  {
      delete obj[key]
    }
  })
}
const removeEmptyFieldValue = queryObject => {
  const keyList = Object.keys(queryObject)
  keyList.forEach((key) => {
    const queryValue = queryObject[key]
    if(queryValue === null || queryValue === '' || queryValue === undefined || queryValue.indexOf('{') > -1) {
      delete queryObject[key]
    }
  })
  return queryObject
}
export default {
  name: 'App',
  methods: {
    goMobileWeb() {
      location.href = location.href.replace(location.origin, 'https://m.wavve.com')
    },
  },
  mounted() {
    const isEmptyPath = location.pathname === '/' || location.pathname === ''
    const deviceType = getDeviceType()
    if((deviceType === DEVICE_TYPE_IOS || deviceType === DEVICE_TYPE_ANDROID) && !isEmptyPath) {
      const linkList = getLinkList(deeplink)
      const targetUrl = location.origin.replace(location.protocol, 'https:')
          .replace(location.host, 'm.wavve.com') + location.pathname
      const currentQuery = parseUrl(location.href).query
      const targetLink = linkList.filter((link) => {
        const comparablePath = _.get(link, 'comparablePath', '')
        if(comparablePath === '') {
          const mWebUrl = parseUrl(_.get(link, 'mweb', '') || '').url
          const mWebQuery = parseUrl(_.get(link, 'mweb', '') || '').query
          const deeplinkQuery = parseUrl(_.get(link, deviceType, '') || '').query
          if(_.isEmpty(mWebQuery) && _.isEmpty(deeplinkQuery)) {
            return mWebUrl === targetUrl
          }else {
            const emptyCurrentQuery = removeExceptionalParam(makeEmptyObject(Object.keys(currentQuery)))
            const emptyIosQuery = removeExceptionalParam(makeEmptyObject(Object.keys(deeplinkQuery)))
            return mWebUrl === targetUrl && _.isEqual(emptyCurrentQuery, emptyIosQuery)
          }
        }else {
          return comparablePath !== '' && comparePath(parseUrl(comparablePath).url, targetUrl)
        }
      })
      if(_.isEmpty(targetLink)) this.goMobileWeb()
      const link = targetLink[0]
      const deviceDeepLinkFullUrl = _.get(link, deviceType, '') || ''
      if(deviceDeepLinkFullUrl === '') this.goMobileWeb()
      const deviceDeepLinkUrl  = parseUrl(deviceDeepLinkFullUrl).url
      const deviceDeepLinkQuery = parseUrl(deviceDeepLinkFullUrl).query
      const hasPathParam = _.get(link, 'pathParam', '') !== ''
      const hasQueryParam = !_.isEmpty(_.get(link, 'queryParam', {})) || !_.isEmpty(deviceDeepLinkQuery)
      let assignedQuery = {}
      if(hasPathParam) {
        const pathParam = _.get(link, 'pathParam', '')
        if(currentQuery[pathParam] === undefined || currentQuery[pathParam] === '') {
          const mWebPathList = parseUrl(link.mweb).url.split('/')
          const currPathList = parseUrl(location.href).url.split('/')
          mWebPathList.forEach((path, index) => {
            if(path.indexOf('{') > -1 && path.indexOf('}') > -1) {
              const key = path.replace('{', '').replace('}', '')
              assignedQuery[key] = currPathList[index]
            }
          })
        }else {
          assignedQuery[pathParam] = currentQuery[pathParam]
        }
      }
      if(hasQueryParam) {
        assignedQuery = Object.assign({}, deviceDeepLinkQuery, currentQuery, assignedQuery)
        //INFO: 위의 targetLink filter 하는과정에서 query 까지 검사 해야 하는데 query 검사 않고, 쿼리가 있으면 url 만 검사해봐서 이런 문제가 발생함
        //급한대로 이대로 나가고 추후 수정할예정
        assignedQuery = removeEmptyFieldValue(assignedQuery)
      }
      delete assignedQuery.came
      const completeDeviceDeepLinkUrl = stringifyUrl({url: deviceDeepLinkUrl, query: assignedQuery})
      setTimeout(() => {
        if(deviceType === DEVICE_TYPE_IOS) {
          openIosDeepLink(completeDeviceDeepLinkUrl)
        }else if(deviceType === DEVICE_TYPE_ANDROID) {
          openAndroidDeepLink(completeDeviceDeepLinkUrl)
        }
      }, 1000)
    }
  }
};
</script>
<style lang="css" src="@/assets/css/style.css"></style>

